import React from "react"
import styled from "@emotion/styled"

export const ContentContainer = props => (
  <Contentcontainer {...props}></Contentcontainer>
)

const Contentcontainer = styled.section`
  color: #292944;
  font-size: 14px;
  max-width: 600px;

  h3 {
    font-weight: 500;
  }
  h4 {
    color: #4b4b65;
    margin-bottom: 10px;
  }
  a {
    color: #5558ea;
    :hover {
      text-decoration: underline;
    }
  }
`
